import { get } from 'lodash';

export const isForbiddenAPIError = (error) => get(error, 'response.status') === 403;
